export const MAX_ITEMS: number = 4;

export const REMOVE_ACTION_NAME: string = 'remove';
export const ADD_ACTION_NAME: string = 'add';
